import { Flex, Button, Text, Link } from '@chakra-ui/react';

const CustomPlanOfferCardActions = ({
  status,
  contractRequired,
  onRequestChanges,
  onAccept,
  acceptLoading,
}) => {
  if (status === 'pending_signature') {
    return (
      <Flex justifyContent="flex-end" mt={4}>
        <Button
          as={Link}
          href="mailto:sales@passentry.com"
          variant="secondary"
          size="md"
          bg="white"
          _hover={{ textDecoration: 'none' }}
        >
          <Text>Contact us</Text>
        </Button>
      </Flex>
    );
  }

  if (status === 'signature_received') {
    return (
      <Flex justifyContent="flex-end" mt={4}>
        <Button
          variant="gradient"
          size="md"
          onClick={onAccept}
          isLoading={acceptLoading}
          loadingText="Processing..."
          minW="180px"
        >
          Confirm and Pay
        </Button>
      </Flex>
    );
  }

  if (status === 'accepted') {
    return (
      <Flex justifyContent="flex-end" mt={4}>
        <Button
          variant="gradient"
          size="md"
          onClick={onAccept}
          isLoading={acceptLoading}
          loadingText="Processing..."
          minW="180px"
        >
          Confirm and Pay
        </Button>
      </Flex>
    );
  }

  if (status === 'offer_sent') {
    if (contractRequired) {
      return (
        <Flex
          justifyContent="space-between"
          direction={{ base: 'column', md: 'row' }}
          gap={4}
        >
          <Text
            textStyle="bodyFamilyRegular"
            fontSize="12px"
            color="gray.600"
            mt={4}
          >
            This plan will replace your current plan. Any unused time or
            payments will be credited towards your new plan.
          </Text>
          <Flex
            justifyContent="flex-end"
            alignItems={{ base: 'stretch', lg: 'flex-end' }}
            gap={3}
            direction={{ base: 'column', md: 'row' }}
          >
            <Button
              variant="secondary"
              size="md"
              onClick={onRequestChanges}
              isDisabled={acceptLoading}
              bg="white"
            >
              <Text>Request changes</Text>
            </Button>
            <Button
              variant="gradient"
              size="md"
              onClick={onAccept}
              isLoading={acceptLoading}
              loadingText="Processing..."
              minW="180px"
            >
              Accept offer
            </Button>
          </Flex>
        </Flex>
      );
    }

    return (
      <Flex
        justifyContent="space-between"
        direction={{ base: 'column', md: 'row' }}
        gap={4}
      >
        <Text
          textStyle="bodyFamilyRegular"
          fontSize="12px"
          color="gray.600"
          mt={4}
        >
          This plan will replace your current plan. Any unused time or payments
          will be credited towards your new plan.
        </Text>
        <Flex
          justifyContent="flex-end"
          alignItems={{ base: 'stretch', lg: 'flex-end' }}
          gap={3}
          direction={{ base: 'column', md: 'row' }}
        >
          <Button
            variant="secondary"
            size="md"
            onClick={onRequestChanges}
            isDisabled={acceptLoading}
            bg="white"
          >
            <Text>Request changes</Text>
          </Button>
          <Button
            variant="gradient"
            size="md"
            onClick={onAccept}
            isLoading={acceptLoading}
            loadingText="Processing..."
            minW="180px"
          >
            Review & Accept
          </Button>
        </Flex>
      </Flex>
    );
  }

  return null;
};

export default CustomPlanOfferCardActions;
